export const NOTIFY_OPEN = 'notify_open';
export const NOTIFY_CLOSE = 'notify_close';